import type { UseFormReturnType } from '@mantine/form';
import type { z } from 'zod';
import { ApiError } from '../api/client';

/** Validador de @mantine/form a partir de un esquema Zod compartido con la API. */
export function zodValidator<S extends z.ZodType>(schema: S) {
  return (values: unknown): Record<string, string> => {
    const result = schema.safeParse(values);
    if (result.success) return {};
    const errors: Record<string, string> = {};
    for (const issue of result.error.issues) {
      const key = issue.path.join('.');
      errors[key] ??= issue.message;
    }
    return errors;
  };
}

/** Lleva los errores por campo devueltos por la API al formulario. Devuelve true si había alguno. */
export function applyApiFieldErrors<T>(form: UseFormReturnType<T>, error: unknown): boolean {
  if (error instanceof ApiError && error.fields && Object.keys(error.fields).length > 0) {
    form.setErrors(error.fields);
    return true;
  }
  return false;
}
